import { defineMessages } from 'react-intl';

export default defineMessages({
  optionTitleLeft: 'All',
  optionTitleRight: 'Stable Coins',
  total: 'Total',

  changeMarket: 'Can’t find your asset? {button}',
});
